@if (isContractCreated === true) {
<div class="contract-summary">
  @if (blockedUi) {
  <div class="fp-block-ui-overlay" aria-live="polite" aria-busy="true">
    <i class="pi pi-spin pi-spinner loading" [style.display]="blockedUi ? 'block' : 'none'"></i>
  </div>
  }
  <div class="contract-created-card">
    <div class="contract-created-content">
      <h1>{{ 'TRANSLATE.CONGRATULATIONS' | translate }}</h1>
      <h3>
        {{ 'TRANSLATE.YOU.HAVE.JUST.PURCHASED.FORD.PROTECT' | translate }}
      </h3>
      <h3>
        {{ 'TRANSLATE.NEXT.YOU.CAN.ACCESS.CONTRACT.TEXT' | translate }}
      </h3>
      <h3>
        {{ 'TRANSLATE.THANK.YOU.AND.COUNT.ON.US' | translate }}
      </h3>
    </div>
    <div class="col-12 md:col-12 lg:col-12 button-position contract-created-action">
      <button id="btnDownload" class="btn-download contract-created-download" type="button"
        [disabled]="isDownloadingContract" [ngClass]="{ 'is-loading': isDownloadingContract }"
        [attr.aria-busy]="isDownloadingContract" (click)="downloadPDF()">
        @if (!isDownloadingContract) {
        <i class="pi pi-download" aria-hidden="true"></i>
        }
        @if (isDownloadingContract) {
        <i class="pi pi-spin pi-spinner" aria-hidden="true"></i>
        }
        <span class="btn-download-span">{{ (isDownloadingContract ? 'TRANSLATE.DOWNLOADING.TERMS.OF.AGREEMENT' :
          'TRANSLATE.DOWNLOAD.TERMS.OF.AGREEMENT') | translate }}</span>
      </button>
    </div>
  </div>
</div>
}

@if (isContractCreated === false) {
<div class="contract-summary">
  @if (blockedUi) {
  <div class="fp-block-ui-overlay" aria-live="polite" aria-busy="true">
    <i class="pi pi-spin pi-spinner loading" [style.display]="blockedUi ? 'block' : 'none'"></i>
  </div>
  }
  <div class="contract-wrapper">
    <div class="col-11 md:col-12 lg:col-12 page-content">
      <div class="col-12 md:col-12 lg:col-12 image-position">
        <img class="contract-logo" src="../../../assets/image/FordProtect_Blue_RGB_Hz_v1.png" alt="Ford Protect">
      </div>
      <div class="col-12 text-content">
        <h4 class="styling-the-title">TÉRMINOS Y CONDICIONES DE PLAN DE MANTENIMIENTO PREPAGO FORD PROTECT</h4>
        <hr class="styling-the-hr" />
      </div>
      <div class="col-12 top-element">
        <div class="header">
          <h5 class="header-title">CLIENTE</h5>
        </div>
        <div class="info-box top-box">
          <div class="first-line">
            <h5 class="bold-words">NOMBRE:</h5>
            <p>{{ completeName }}</p>
          </div>
          <div class="first-line">
            <h5 class="bold-words">D.N.I/CUIT:</h5>
            <p>{{ clientData.nationalId }}</p>
          </div>
          <div class="first-line">
            <h5 class="bold-words">DOMICILIO:</h5>
            <p [innerHTML]="fullAddressFormatted"></p>
          </div>
          <div class="first-line-position">
            <div class="first-line">
              <h5 class="bold-words">TELÉFONO:</h5>
              <p>{{ clientData.phone1 }}</p>
            </div>
            <div class="first-line space">
              <h5 class="bold-words">E-MAIL:</h5>
              <p>{{ clientData?.email1.toLowerCase() }}</p>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 top-element">
        <div class="header">
          <h5 class="header-title">CONCESIONARIO</h5>
        </div>
        <div class="info-box top-box-second">
          <div class="elements-below-each-other">
            <div class="first-line">
              <h5 class="bold-words">RAZON SOCIAL:</h5>
              <p>{{ dealerName }}</p>
            </div>
            <div class="first-line">
              <h5 class="bold-words">CUIT:</h5>
              <p>{{ dealer?.nationalId }}</p>
            </div>
            <div class="first-line">
              <h5 class="bold-words">DOMICILIO:</h5>
              <p [innerHTML]="dealerFullAddressFormatted"></p>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 top-element">
        <div class="header">
          <h5 class="header-title">DATOS DEL VEHÍCULO</h5>
        </div>
        <div class="info-box top-box-third">
          <div class="first-line-position">
            <div class="first-line">
              <i class="fas fa-solid fa-car-side icon-style"></i>
            </div>
            <div class="first-line space-car-image">
              <h5 class="bold-words">MODELO:</h5>
              <p>{{ vinValidate.modelName.toUpperCase() }}</p>
            </div>
            <div class="first-line space-car-image-second">
              <h5 class="bold-words">CHASIS:</h5>
              <p>{{ vinValidate.vin }}</p>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 top-element">
        <div class="header">
          <h5 class="header-title">PLAN Y PRECIO</h5>
        </div>
        <div class="info-box top-box-fourth">
          <div class="first-line-position">
            <div class="first-line">
              <i class="fas fa-regular fa-dollar-sign icon-style"></i>
            </div>
            <div class="first-line space-plan-price">
              <h5 class="bold-words">PLAN CONTRATADO:</h5>
              <p>{{ choosePlanBuyng.maintenance.planName }}</p>
            </div>
            <div class="first-line space-price-value">
              <h5 class="bold-words">PRECIO:</h5>
              <p>$ {{ choosePlanBuyng.totalPrice | number: '1.2-2' : 'en-US' }}</p>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 top-element">
        <ol class="contract-numbered-list">
          <li>
            <div class="contract-numbered-content">
              <h5 class="contract-paragraph contract-section-title bold-words">OBJETO Y DEFINICIONES</h5>
              <ol>
                <li>
                  <div class="contract-numbered-content">
                    <p class="contract-paragraph">
                      Mediante el presente Contrato de Adhesión (en adelante, el “Contrato”), el
                      <span class="bold-words">CONTRATANTE</span> suscribe, a través del
                      <span class="bold-words">CONCESIONARIO AUTORIZADO</span>, el Servicio de mantenimiento
                      prepago denominado “Ford Protect” (en adelante, “Ford Protect”), concebido por
                      <span class="bold-words">FORD ARGENTINA S.C.A.</span>, con sede en French 3155, Piso 1, Ciudad
                      Autónoma de Buenos Aires (en adelante, “<span class="bold-words">FORD</span>”), para propietarios
                      de vehículos de la marca Ford. Dentro de Ford Protect, el
                      <span class="bold-words">CONTRATANTE</span> podrá seleccionar la modalidad o plan específico que
                      resulte aplicable, conforme las opciones disponibles y las condiciones indicadas en el presente
                      Contrato y en el Cuadro de datos.
                    </p>
                  </div>
                </li>
                <li>
                  <div class="contract-numbered-content">
                    <p class="contract-paragraph"><span class="bold-words">Definiciones:</span></p>
                    <ul class="contract-definition-list">
                      <li>
                        <span class="bold-words">CONCESIONARIO y QL AUTORIZADO:</span>
                        integrante de la red oficial de concesionarios y/o Quick Lane de Ford Argentina SCA.
                      </li>
                      <li>
                        <span class="bold-words">FORD PROTECT:</span>
                        servicio de mantenimiento prepago contratado por el CONTRATANTE, dentro del cual podrá
                        seleccionarse una modalidad o plan específico conforme las opciones disponibles.
                      </li>
                      <li>
                        <span class="bold-words">PLAN SELECCIONADO:</span>
                        modalidad específica de Ford Protect elegida por el CONTRATANTE, que determina la cantidad de
                        servicios de mantenimiento programado incluidos, su alcance, condiciones de uso, vigencia,
                        precio y demás condiciones aplicables, conforme el Cuadro de datos.
                      </li>
                      <li>
                        <span class="bold-words">VEHÍCULO:</span>
                        unidad automotor de la marca Ford respecto de la cual se contrata el servicio Ford Protect.
                      </li>
                    </ul>
                  </div>
                </li>
              </ol>
            </div>
          </li>
          <li>
            <div class="contract-numbered-content">
              <h5 class="contract-paragraph contract-section-title bold-words">ALCANCE DE FORD PROTECT Y PLAN SELECCIONADO</h5>
              <ol>
                <li>
                  <div class="contract-numbered-content">
                    <p class="contract-paragraph">
                      Ford Protect tiene por objeto la realización de servicios de mantenimiento periódico, tomando en
                      cuenta la periodicidad recomendada, el kilometraje del Vehículo o, si el Vehículo cuenta con
                      dicho equipamiento, la indicación proporcionada por el Monitor Inteligente de Vida del Aceite
                      (IOLM), aplicándose la condición que ocurra primero, conforme se estipula en el Manual del
                      Propietario y/o Manual de Garantía y Mantenimiento de la unidad. La cantidad de servicios
                      incluidos, su alcance específico, vigencia, precio y demás condiciones particulares dependerán del
                      Plan Seleccionado por el CONTRATANTE dentro de Ford Protect.
                    </p>
                  </div>
                </li>
                <li>
                  <div class="contract-numbered-content">
                    <p class="contract-paragraph">
                      Los Programas de mantenimiento periódico estándar incluyen todas las operaciones, inspecciones,
                      verificaciones y reemplazos de piezas previstos en el Programa de Mantenimiento aplicable a la
                      unidad, según modelo y tipo de servicio requerido, ya sea por kilometraje, tiempo o IOLM, lo que
                      ocurra primero, conforme se encuentren publicados por Ford Argentina S.C.A. en
                      <a href="https://www.ford.com.ar" target="_blank" rel="noopener">www.ford.com.ar</a> y/o
                      indicados en el Manual del Propietario y/o de Garantía.
                    </p>
                  </div>
                </li>
                <li>
                  <div class="contract-numbered-content">
                    <p class="contract-paragraph">
                      En los Programas de Mantenimiento de Uso Intensivo, exclusivos para los modelos Ford Ranger, se
                      incluirá adicionalmente la sustitución de todos los elementos filtrantes de aire y polen en todos
                      los servicios de mantenimiento prepagos contratados.
                    </p>
                  </div>
                </li>
                <li>
                  <div class="contract-numbered-content">
                    <p class="contract-paragraph">
                      Quedan <span class="bold-words">excluidos</span> de Ford Protect los servicios, repuestos,
                      piezas, trabajos o reparaciones que no se encuentren expresamente previstos en el Programa de
                      Mantenimiento aplicable a la unidad o en los términos publicados por Ford Argentina S.C.A.;
                      incluyendo, sin limitación, reparaciones por siniestros, mal uso, desgaste no programado,
                      servicios derivados de intervenciones de talleres no autorizados y cualquier reparación o
                      reemplazo de piezas distintas a las especificadas en el Plan Seleccionado.
                    </p>
                  </div>
                </li>
                <li>
                  <div class="contract-numbered-content">
                    <p class="contract-paragraph">
                      <span class="bold-words">Planes disponibles dentro de Ford Protect.</span>
                      Dentro del servicio Ford Protect, el CONTRATANTE podrá seleccionar alguno de los siguientes
                      planes, sujeto a disponibilidad comercial y a las condiciones aplicables al Vehículo:
                    </p>
                    <ul class="contract-definition-list">
                      <li>
                        <span class="bold-words">Ford Protect Basic2</span>, que incluye los primeros 2 (dos)
                        servicios de mantenimiento programado para Vehículo 0 km.
                      </li>
                      <li>
                        <span class="bold-words">Ford Protect Basic3</span>, que incluye los primeros 3 (tres)
                        servicios de mantenimiento programado para Vehículo 0 km.
                      </li>
                      <li>
                        <span class="bold-words">Ford Protect Intensivo</span>, que incluye los primeros 3 (tres)
                        servicios de mantenimiento programado para Vehículo 0 Km, con inclusión del cambio de filtro de
                        aire y filtro de polen en todos los servicios contratados.
                      </li>
                      <li>
                        <span class="bold-words">Ford Protect Next2 (2 servicios)</span>, que incluye 2 (dos)
                        servicios de mantenimiento programado consecutivos para el Vehículo a partir de la fecha de
                        contratación.
                      </li>
                      <li>
                        <span class="bold-words">Ford Protect Next3 (3 servicios)</span>, que incluye 3 (tres)
                        servicios de mantenimiento programado consecutivos para el Vehículo. El detalle específico del
                        Plan Seleccionado, incluyendo servicios, kilometrajes, plazos, piezas incluidas y precio
                        aplicable, será el previsto en el Cuadro de datos y/o en las condiciones comerciales vigentes al
                        momento de contratación.
                      </li>
                    </ul>
                  </div>
                </li>
              </ol>
            </div>
          </li>
          <li>
            <div class="contract-numbered-content">
              <h5 class="contract-paragraph contract-section-title bold-words">VIGENCIA</h5>
              <ol>
                <li>
                  <div class="contract-numbered-content">
                    <p class="contract-paragraph">
                      Ford Protect permanecerá vigente desde la fecha de pago total e íntegro del servicio contratado
                      hasta la finalización de los servicios incluidos en el Plan Seleccionado, o hasta el vencimiento
                      del período de cobertura aplicable, lo que ocurra primero.
                    </p>
                    <p class="contract-paragraph">
                      Los plazos de referencia serán: a) <span class="bold-words">Ford Protect Basic2</span>: 24
                      (veinticuatro) meses, o al finalizar los servicios contratados una vez alcanzado el kilometraje
                      máximo programado aplicable; b) <span class="bold-words">Ford Protect Basic3</span>: 36
                      (treinta y seis) meses, o al finalizar los servicios contratados una vez alcanzado el kilometraje
                      máximo programado aplicable; c) <span class="bold-words">Ford Protect Intensivo (3 servicios)</span>:
                      36 (treinta y seis) meses, o al finalizar los servicios contratados, sujeto a los intervalos de
                      tiempo y kilometraje especificados en el Manual del Propietario; d)
                      <span class="bold-words">Ford Protect Next2 (2 servicios)</span>: 24 (veinticuatro) meses, o al
                      finalizar los servicios contratados, sujeto a los intervalos de tiempo y kilometraje
                      especificados en el Manual del Propietario; y e)
                      <span class="bold-words">Ford Protect Next3 (3 servicios)</span>: 36 (treinta y seis) meses, o
                      al finalizar los servicios contratados, sujeto a los intervalos de tiempo y kilometraje
                      especificados en el Manual del Propietario; conforme el plazo, kilometraje y condiciones indicados
                      en el Cuadro de datos y/o en las condiciones comerciales vigentes al momento de contratación.
                    </p>
                  </div>
                </li>
                <li>
                  <div class="contract-numbered-content">
                    <p class="contract-paragraph">
                      El presente Contrato se considerará efectivo y se activará Ford Protect únicamente tras el pago
                      efectivo e íntegro del precio correspondiente al servicio contratado y al Plan Seleccionado. En
                      ninguna circunstancia se prorrogará la vigencia del presente Contrato, salvo lo previsto para
                      demoras no imputables al CONTRATANTE.
                    </p>
                  </div>
                </li>
                <li>
                  <div class="contract-numbered-content">
                    <p class="contract-paragraph">
                      <span class="bold-words">Demoras no imputables al CONTRATANTE.</span>
                      En caso de que la realización de un servicio incluido en Ford Protect se demore por causas
                      atribuibles al Concesionario y QL autorizado o a la Red de Concesionarios Autorizados Ford, tales
                      como falta de turnos disponibles, demora en la provisión de repuestos o indisponibilidad
                      operativa no imputable al CONTRATANTE, dicha circunstancia no podrá perjudicar la cobertura del
                      Plan Seleccionado respecto del servicio afectado, siempre que el CONTRATANTE acredite haber
                      solicitado el turno dentro de los plazos o tolerancias previstos en la Cláusula 3.4.
                    </p>
                    <p class="contract-paragraph">
                      En tales casos, el plazo de vigencia previsto en la Cláusula 3.1 se prorrogará automáticamente
                      por un período equivalente a la demora acreditada, sin costo adicional para el CONTRATANTE, hasta
                      tanto el servicio afectado sea efectivamente realizado.
                    </p>
                  </div>
                </li>
                <li>
                  <div class="contract-numbered-content">
                    <p class="contract-paragraph">
                      <span class="bold-words">Tolerancia.</span>
                      Según lo establecido en el Manual del Propietario y/o Garantía, la tolerancia máxima para la
                      realización de los servicios de mantenimiento periódico será de 1 (un) mes o 1.000 km, con un
                      margen de más o menos respecto del intervalo definido, según corresponda: por tiempo transcurrido,
                      hasta 1 (un) mes antes o después del intervalo previsto; y por kilometraje, hasta 1.000 km antes
                      o después del kilometraje definido. Para vehículos equipados con Monitor Inteligente de Vida del
                      Aceite (IOLM), la tolerancia aplicable para cada elemento específico deberá consultarse en el
                      Manual del Propietario.
                    </p>
                  </div>
                </li>
              </ol>
            </div>
          </li>
          <li>
            <div class="contract-numbered-content">
              <h5 class="contract-paragraph contract-section-title bold-words">PRECIO Y FORMA DE PAGO</h5>
              <ol>
                <li>
                  <div class="contract-numbered-content">
                    <p class="contract-paragraph">
                      El precio total de Ford Protect será el correspondiente al Plan Seleccionado por el CONTRATANTE e
                      indicado en el Cuadro de datos, pudiendo abonarse en un pago único o en cuotas, según lo acordado
                      al momento de la contratación. Dicho precio incluye los servicios y piezas especificados para el
                      Plan Seleccionado en el presente instrumento y/o en el Cuadro de datos, a realizarse en los
                      intervalos de tiempo, kilometraje o IOLM aplicables, así como los costos, impuestos, tasas,
                      aranceles o cargos que resulten aplicables.
                    </p>
                  </div>
                </li>
                <li>
                  <div class="contract-numbered-content">
                    <p class="contract-paragraph">
                      El CONTRATANTE reconoce y acepta que cualquier servicio de mantenimiento, repuesto, pieza o
                      prestación adicional no cubierto por Ford Protect o por el Plan Seleccionado deberá ser abonado
                      por separado al Concesionario y QL autorizado Ford, de conformidad con los términos informados y
                      autorizados al momento de realizarse dichos servicios o prestaciones.
                    </p>
                  </div>
                </li>
              </ol>
            </div>
          </li>
          <li>
            <div class="contract-numbered-content">
              <h5 class="contract-paragraph contract-section-title bold-words">EJECUCIÓN DE LOS SERVICIOS</h5>
              <ol>
                <li>
                  <div class="contract-numbered-content">
                    <p class="contract-paragraph">
                      Para utilizar Ford Protect conforme el Plan Seleccionado, el CONTRATANTE deberá seleccionar un
                      Concesionario y QL autorizado Ford de su elección y programar una cita. La lista de
                      Concesionarios Autorizado Ford podrá consultarse en
                      <a href="https://www.ford.com.ar" target="_blank" rel="noopener">www.ford.com.ar</a>, mediante la
                      aplicación Ford o Agenda Ford.
                    </p>
                  </div>
                </li>
                <li>
                  <div class="contract-numbered-content">
                    <p class="contract-paragraph">
                      El CONTRATANTE deberá presentarse en el Concesionario y QL autorizado Ford elegido provisto del
                      Manual del Propietario del Vehículo. El tiempo requerido para la realización de los servicios podrá
                      variar según el volumen de citas de servicio en curso en la fecha programada.
                    </p>
                  </div>
                </li>
                <li>
                  <div class="contract-numbered-content">
                    <p class="contract-paragraph">
                      <span class="bold-words">Presupuesto y autorización previa.</span>
                      En caso de que resulte necesario realizar un servicio de mantenimiento, repuesto, pieza,
                      reparación o trabajo adicional no incluido en Ford Protect, en el Plan Seleccionado o en el Cuadro
                      de datos, el Consultor Técnico del Concesionario y QL autorizado Ford deberá informar previamente
                      al CONTRATANTE qué elementos no se encuentran cubiertos por el servicio contratado y deberá
                      presupuestarlos por escrito, detallando, según corresponda, repuestos, mano de obra, precio final
                      y plazo estimado de ejecución. Dichos trabajos adicionales requerirán
                      <span class="bold-words">autorización expresa y previa del CONTRATANTE</span> antes de su
                      realización.
                    </p>
                  </div>
                </li>
                <li>
                  <div class="contract-numbered-content">
                    <p class="contract-paragraph">
                      <span class="bold-words">Garantía sobre los servicios realizados.</span>
                      Todo servicio de mantenimiento ejecutado en el marco de Ford Protect y conforme el Plan
                      Seleccionado queda garantizado en sus trabajos y repuestos colocados por un plazo mínimo de 30
                      (treinta) días corridos desde su finalización, sin costo adicional para el CONTRATANTE, sin
                      perjuicio de garantías legales o de fábrica superiores que resulten aplicables.
                    </p>
                  </div>
                </li>
                <li>
                  <div class="contract-numbered-content">
                    <p class="contract-paragraph">
                      Levar el Vehículo a un Concesionario y QL autorizado Ford para la realización de los servicios de
                      mantenimiento periódico dentro de los intervalos definidos constituye una obligación del
                      CONTRATANTE y resulta esencial para el correcto y seguro funcionamiento del Vehículo, así como
                      para procurar su rendimiento y durabilidad óptima.
                    </p>
                  </div>
                </li>
              </ol>
            </div>
          </li>
          <li>
            <div class="contract-numbered-content">
              <h5 class="contract-paragraph contract-section-title bold-words">TRANSFERENCIA DE FORD PROTECT</h5>
              <ol>
                <li>
                  <div class="contract-numbered-content">
                    <p class="contract-paragraph">
                      Ford Protect y los servicios de mantenimiento prepagos incluidos en el Plan Seleccionado se
                      encuentran asociados al número de serie de cada unidad, siendo propios y exclusivos de cada
                      Vehículo. En caso de venta del vehículo, los servicios pendientes de realización continuarán
                      asociados a la unidad y serán transferibles al nuevo propietario.
                    </p>
                  </div>
                </li>
                <li>
                  <div class="contract-numbered-content">
                    <p class="contract-paragraph">
                      En caso de destrucción total o robo de la unidad, los servicios pendientes de realización
                      incluidos en el Plan Seleccionado podrán ser transferidos a una nueva unidad de iguales
                      condiciones. Si ello no resultara posible, corresponderá la devolución proporcional de los
                      servicios pendientes de realización, conforme las reglas de reembolso previstas en el presente
                      instrumento.
                    </p>
                  </div>
                </li>
              </ol>
            </div>
          </li>
          <li>
            <div class="contract-numbered-content">
              <h5 class="contract-paragraph contract-section-title bold-words">RESCISIÓN Y REEMBOLSO</h5>
              <ol>
                <li>
                  <div class="contract-numbered-content">
                    <p class="contract-paragraph">
                      <span class="bold-words">Derecho de rescisión.</span>
                      El CONTRATANTE podrá solicitar la rescisión de Ford Protect en cualquier momento, mediante
                      comunicación fehaciente a FORD ARGENTINA. En tal caso, y en la medida en que existan servicios
                      abonados y no utilizados dentro del Plan Seleccionado, corresponderá el reembolso del saldo
                      restante conforme el mecanismo previsto en la presente cláusula.
                    </p>
                  </div>
                </li>
                <li>
                  <div class="contract-numbered-content">
                    <p class="contract-paragraph">
                      <span class="bold-words">Reembolso.</span>
                      El reembolso, cuando corresponda, será calculado de manera proporcional dividiendo el precio
                      histórico total abonado por la cantidad total de servicios contratados y multiplicando dicho valor
                      por la cantidad de servicios no utilizados al momento de la rescisión.
                    </p>
                  </div>
                </li>
                <li>
                  <div class="contract-numbered-content">
                    <p class="contract-paragraph">
                      El reembolso deberá efectivizarse dentro de los 10 (diez) días hábiles desde la recepción del
                      reclamo de rescisión, mediante el mismo medio de pago utilizado por el CONTRATANTE, salvo que este
                      indique otro.
                    </p>
                  </div>
                </li>
              </ol>
            </div>
          </li>
          <li>
            <div class="contract-numbered-content">
              <h5 class="contract-paragraph contract-section-title bold-words">CASO FORTUITO Y FUERZA MAYOR</h5>
              <ol>
                <li>
                  <div class="contract-numbered-content">
                    <p class="contract-paragraph">
                      Ninguna de las partes será responsable por incumplimientos derivados de caso fortuito o fuerza
                      mayor, en los términos de los Arts. 1730 y 1731 del Código Civil y Comercial de la Nación.
                    </p>
                  </div>
                </li>
                <li>
                  <div class="contract-numbered-content">
                    <p class="contract-paragraph">
                      FORD no asumirá responsabilidad ni reconocerá costos o gastos incurridos por el CONTRATANTE en
                      relación con servicios realizados fuera de los Concesionarios Autorizados Ford, cuyo listado se
                      actualiza periódicamente y se publica en el sitio web de FORD, ni por servicios, repuestos,
                      piezas o trabajos realizados fuera del alcance previsto para Ford Protect, para el Plan
                      Seleccionado, en estos Términos o en el Cuadro de datos.
                    </p>
                  </div>
                </li>
                <li>
                  <div class="contract-numbered-content">
                    <p class="contract-paragraph">
                      En caso de dudas respecto de los servicios y productos recomendados para el mantenimiento del
                      Vehículo, el CONTRATANTE podrá consultar el Manual del Propietario. En caso de discrepancia entre
                      el Manual del Propietario y estos Términos respecto del alcance económico de Ford Protect o del
                      Plan Seleccionado, Ford Protect incluirá única y exclusivamente los servicios, piezas y
                      prestaciones expresamente previstos en estos Términos, en el Plan Seleccionado y/o en el Cuadro
                      de datos, los cuales se realizarán de conformidad con las especificaciones técnicas
                      correspondientes a cada intervalo de servicio programado.
                    </p>
                  </div>
                </li>
              </ol>
            </div>
          </li>
          <li>
            <div class="contract-numbered-content">
              <h5 class="contract-paragraph contract-section-title bold-words">PROTECCIÓN DE DATOS PERSONALES</h5>
              <ol>
                <li>
                  <div class="contract-numbered-content">
                    <p class="contract-paragraph">
                      En cumplimiento de la Ley N° 25.326 de Protección de Datos Personales, se informa al CONTRATANTE
                      que los datos solicitados resultan necesarios para el análisis, contratación, administración y
                      ejecución de Ford Protect y deberán ser brindados en forma exacta. La información será tratada de
                      manera segura y conforme los parámetros normativos aplicables. FORD podrá eventualmente utilizar
                      los datos para comunicaciones vinculadas con productos Ford, acciones de marketing y publicidad, o
                      compartirlos con Plan Ovalo S.A. de Ahorro para Fines Determinados y otras empresas asociadas y/o
                      sus concesionarios autorizados, en la medida permitida por la normativa aplicable. Asimismo, el
                      Contratante presta su consentimiento para que sus datos puedan encontrarse alojados en el
                      territorio de la República Argentina como en cualquier país extranjero, incluyendo aquellos que no
                      cuentan con niveles adecuados de protección en materia de datos personales, en comparación con lo
                      exigido en Argentina. Sus datos serán incorporados en una base de datos registrada por Ford
                      Argentina SCA, con domicilio en French 3155, Piso 1° de la Ciudad Autónoma de Buenos Aires.
                    </p>
                  </div>
                </li>
                <li>
                  <div class="contract-numbered-content">
                    <p class="contract-paragraph">
                      El Contratante tiene derecho a acceder a sus datos personales en forma gratuita con intervalos no
                      inferiores a seis (6) meses, salvo que se acreditara un interés legítimo al efecto, de
                      conformidad con lo previsto en el art. 14, inc. 3° de la Ley 25.326, así como a solicitar que sus
                      datos sean rectificados, actualizados o removidos de la base de datos personales de Ford
                      Argentina S.C.A.. A tal efecto, el Contratante deberá comunicarse con el Centro de Atención al
                      Cliente de Ford Argentina al tel. 0800-888-FORD (3673), o bien enviar un mail a
                      <a href="mailto:privacy3&#64;ford.com">privacy3&#64;ford.com</a>. En el caso de solicitar
                      rectificación, supresión o actualización de los datos personales, se realizará en el plazo máximo
                      de cinco días hábiles de recibido el reclamo. Asimismo, informamos que la AGENCIA DE ACCESO A LA
                      INFORMACIÓN PÚBLICA, en su carácter de Órgano de Control de la Ley N° 25.326, tiene la
                      atribución de atender las denuncias y reclamos que interpongan quienes resulten afectados en sus
                      derechos por incumplimiento de las normas vigentes en materia de protección de datos personales.
                    </p>
                    <p class="contract-paragraph">
                      Para mayor información consulte nuestra Política de Privacidad en el siguiente enlace
                      <a href="https://www.ford.com.ar/politicas/" target="_blank"
                        rel="noopener">https://www.ford.com.ar/politicas/</a>
                    </p>
                  </div>
                </li>
              </ol>
            </div>
          </li>
          <li>
            <div class="contract-numbered-content">
              <h5 class="contract-paragraph contract-section-title bold-words">JURISDICCIÓN Y COMPETENCIA</h5>
              <p class="contract-paragraph">
                Para todo conflicto derivado del presente Contrato, será competente el tribunal correspondiente al
                <span class="bold-words">domicilio real del CONTRATANTE</span> al momento de la contratación o al
                momento del conflicto, a elección de este último, siendo
                <span class="bold-words">nula cualquier cláusula que establezca un foro distinto o que implique
                  renuncia a dicha competencia.</span>
              </p>
            </div>
          </li>
        </ol>
      </div>

      <div class="col-12 md:col-12 lg:col-11 button-position">
        <button id="btnReturn" class="btn-return" type="button" (click)="buttonComeBack()" [disabled]="blockedUi">
          <i class="pi pi-arrow-left" aria-hidden="true"></i>
          <span class="btn-return-span">{{ 'TRANSLATE.RETURN' | translate }}</span>
        </button>
        <button id="btnSave" class="btn-save" type="submit" (click)="saveContractButton()"
          [disabled]="blockedUi || !dealerCuitLoaded" [attr.aria-busy]="blockedUi">
          @if (!blockedUi) {
          <i class="pi pi-arrow-right" aria-hidden="true"></i>
          }
          @if (blockedUi) {
          <i class="pi pi-spin pi-spinner" aria-hidden="true"></i>
          }
          <span class="btn-save-span">{{ (blockedUi ? 'TRANSLATE.FINISHING' : 'TRANSLATE.FINALIZE') | translate
            }}</span>
        </button>
      </div>
    </div>
  </div>
</div>
}
